export const SIGNUP_PLATFORMS = ["web", "ios", "android"] as const;

export type SignupPlatform = (typeof SIGNUP_PLATFORMS)[number];

export const SIGNUP_AUTH_METHODS = ["password", "apple", "google"] as const;

export type SignupAuthMethod = (typeof SIGNUP_AUTH_METHODS)[number];

export const isSignupPlatform = (value: unknown): value is SignupPlatform =>
  typeof value === "string" &&
  SIGNUP_PLATFORMS.includes(value as SignupPlatform);

export const isSignupAuthMethod = (value: unknown): value is SignupAuthMethod =>
  typeof value === "string" &&
  SIGNUP_AUTH_METHODS.includes(value as SignupAuthMethod);

